/** Raw hex values for inline styles that can't use CSS variables.
 *  Keep in sync with the domain ramps in apps/web/src/index.css. */
export const DOMAIN_HEX = {
  market:   { base: '#5c8a6b', light: '#7aab8a', dark: '#456b52' }, // Sage green
  business: { base: '#3196e2', light: '#509de4', dark: '#1f689f' }, // Ocean blue
  solution: { base: '#ffc05f', light: '#ffcf6f', dark: '#a66d19' }, // Sunlit gold
} as const

/** Tailwind class sets for the Market-Business-Solution ontology domains */
export const DOMAIN_COLORS: Record<string, { bg: string; text: string; border: string }> = {
  market: { bg: 'bg-market/10', text: 'text-market', border: 'border-market/30' },
  business: { bg: 'bg-business/10', text: 'text-business', border: 'border-business/30' },
  solution: { bg: 'bg-solution/10', text: 'text-solution', border: 'border-solution/30' },
}
